import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { SharedModule } from '../../shared.module';
import { Disclaimers, DisclaimerType } from './disclaimers';
import { AppConfigQuery } from 'src/app/core/state/app-config/app-config.query';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, SharedModule, MatCheckboxModule],
    selector: 'sb-disclaimer',
    standalone: true,
    templateUrl: './sb-disclaimer.component.html',
    styleUrls: ['./sb-disclaimer.component.scss']
})
export class SbDisclaimerComponent implements OnInit {
    @Input('name') disclaimerName: string = '';
    disclaimer: DisclaimerType;

    show: boolean = false;

    constructor(private appConfig: AppConfigQuery) {}

    ngOnInit(): void {
        // Get disclaimers with this name (e.g. market-data)
        const disclaimers = Disclaimers.find(
            (d) => d.name === this.disclaimerName
        )?.disclaimers;

        // Get disclaimers for this environment (e.g. carnegie)
        // ... and set the disclaimer data object in the component
        const theme = this.appConfig.get().cssTheme?.replace(/-theme/, '');
        if (disclaimers) {
            this.disclaimer = disclaimers.find((d) => d.theme === theme);
        }

        // Show disclaimer for this user?
        // ... if local storage hide setting is not set and there is disclaimer data for this environment
        if (this.disclaimer) {
            this.show =
                localStorage.getItem('hide_disclaimer_' + this.disclaimerName) === null;
        }
    }

    onCloseClick(dontShowAgain: boolean): void {
        // Set local storage hide setting if checkbox is checked
        if (dontShowAgain)
            localStorage.setItem('hide_disclaimer_' + this.disclaimerName, 'true');

        // Hide disclaimer
        this.show = false;
    }
}
